import { LoginTranslate } from './loginTranslate.model';

const loginTranslatePTBR: LoginTranslate = {
  signIn: 'Entrar',
  signUp: {
    title: 'Criar conta',
    callToAction: 'Não tem uma conta?',
    linkLabel: 'Cadastre-se',
    haveAccount: 'Já tem uma conta?',
    backToLogin: 'Voltar pro login',
    submit: 'Criar conta',
    fields: {
      name: 'Nome completo',
      passwordConfirmation: 'Confirmar senha',
    },
    errors: {
      name: {
        required: 'Nome é obrigatório',
        invalid: 'Nome deve conter apenas letras',
      },
      passwordConfirmation: {
        required: 'Confirmação de senha é obrigatória',
        mismatch: 'As senhas não coincidem',
      },
      submit: 'Não foi possível criar a conta. Tente novamente',
    },
  },
  fields: {
    email: 'E-mail',
    password: 'Senha',
    code: 'Código',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
  },
  passwordVisibility: {
    show: 'Mostrar senha',
    hide: 'Ocultar senha',
    showConfirmation: 'Mostrar confirmação de senha',
    hideConfirmation: 'Ocultar confirmação de senha',
  },
  errors: {
    email: {
      required: 'E-mail é obrigatório',
      invalid: 'Formato de e-mail inválido',
    },
    password: {
      required: 'Senha é obrigatória',
      invalid: 'Senha deve conter no mínimo 8 caracteres',
    },
    code: {
      required: 'Código é obrigatório',
      invalid: 'Código deve ter 6 dígitos',
    },
    newPassword: {
      required: 'Nova senha é obrigatória',
      minLength: 'A senha deve ter no mínimo 8 caracteres',
    },
    confirmPassword: {
      required: 'Confirmação de senha é obrigatória',
      mismatch: 'As senhas não coincidem',
    },
    authenticate: 'E-mail ou senha inválida',
  },
  passwordConfirmation: {
    title: 'Insira o código recebido via e-mail',
    text: 'Como medida de segurança adicional, insira o código de seis dígitos que enviamos para',
    success: 'E-mail confirmado. Faça login para continuar.',
    buttons: {
      resend: 'Reenviar código',
      confirm: 'Confirmar',
      back: 'Voltar',
    },
  },
  forgotPassword: {
    linkLabel: 'Esqueci minha senha',
    title: 'Esqueci minha senha',
    subtitle:
      'Informe seu email e enviaremos um código para redefinir sua senha',
    submit: 'Enviar código',
    success: 'Código enviado para o seu email',
    backToLogin: 'Voltar pro login',
  },
  confirmForgotPassword: {
    title: 'Redefinir senha',
    subtitle: 'Insira o código recebido por email e sua nova senha',
    submit: 'Redefinir senha',
    backToLogin: 'Voltar pro login',
    success: 'Senha redefinida com sucesso',
    notReceivedHint:
      'Não recebeu o código? Sua conta pode não estar confirmada.',
    confirmAccountLink: 'Confirmar minha conta',
  },
};

export default loginTranslatePTBR;
